import { defineStore } from 'pinia';

import { pinia } from './store.js';

// Идущий собес: сама сессия, лента реплик, часы, черновик ответа.
//
// Данные — здесь, ручки — в компоненте. Ручки тут особенно заметны: запись с
// микрофона, плеер озвучки, четыре таймера. Они привязаны к живому экрану, их
// нельзя ни сохранить, ни восстановить, и в сторе им делать нечего.
//
// Черновик ответа при этом данные, и важные: человек проговорил минуту, текст
// распознался — потерять его из-за случайного перехода нельзя.

export const useInterview = defineStore('interview', {
  state: () => ({
    id: null,
    info: null,
    project: null,
    turns: [],
    draft: '',
    code: '',
    elapsed: 0,
    // Режимы экрана: пишем код вместо речи, ждём приветствие, идёт сборка
    // разбора. Все три меняют то, что показано вместо микрофона.
    codeMode: false,
    awaiting: false,
    wrapping: false,
    showSetup: true,
  }),
  actions: {
    /**
     * Другой собес — чистый экран, и до запроса, а не после.
     *
     * Иначе в новом разговоре долю секунды висит лента прошлого, а в поле —
     * недоговорённый черновик оттуда же.
     */
    open(id) {
      if (this.id === id) return;
      this.id = id;
      this.info = null;
      this.project = null;
      this.turns = [];
      this.draft = '';
      this.code = '';
      this.elapsed = 0;
      this.codeMode = false;
      this.awaiting = false;
      this.wrapping = false;
      this.showSetup = true;
    },

    take(data) {
      this.open(data.session?.id || null);
      this.info = data.session;
      this.project = data.project;
      this.turns = data.turns;
    },
  },
});

export const interview = useInterview(pinia);
